var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0413 32.6618C7.89032 31.8058 4.59131 31.374 1.39105 30.9784C0.701762 30.8954 0.0618066 31.3582 0.0125719 32.0102C-0.0858976 32.6627 0.406738 33.2595 1.04679 33.3424C4.14858 33.7232 7.34855 34.1307 10.3519 34.9548C10.9919 35.1335 11.6815 34.7656 11.8784 34.1326C12.0754 33.5002 11.6814 32.841 11.0413 32.6618Z",
    fill: "#3B3B45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5928 20.5257C15.5216 15.5159 9.81035 11.151 4.83764 6.0068C4.39453 5.52636 3.60677 5.50062 3.11442 5.94912C2.62208 6.3981 2.57303 7.15307 3.06538 7.6335C8.03809 12.7925 13.7493 17.1717 18.8205 22.1962C19.3128 22.6652 20.1004 22.6719 20.5928 22.2105C21.0359 21.7496 21.0851 20.9947 20.5928 20.5257Z",
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0959 1.25626C30.2436 4.12362 30.391 6.99098 30.5387 9.85881C30.5387 10.5156 31.1298 11.0227 31.8191 10.9908C32.5084 10.9584 33.0004 10.3993 33.0004 9.74204C32.8527 6.86992 32.7053 3.99827 32.5576 1.12662C32.5084 0.469834 31.9175 -0.0339561 31.2282 0.00179059C30.5881 0.0375372 30.0467 0.599953 30.0959 1.25626Z",
    fill: "#3B3B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkLines);
export default __webpack_public_path__ + "static/media/spark-lines.0bc4daf12617ce81abc78b1d17f4290c.svg";
export { ForwardRef as ReactComponent };